'use client';
const defaultSerializer = (...args)=>{
    return JSON.stringify(args);
};

export { defaultSerializer };
//# sourceMappingURL=defaultSerializer.js.map
